<template>
  <div class="exam-answer-page">
    <b-container>
      <breadcrumb :listBreadcrumb="listBreadcrumb" />
      <b-row>
        <b-col class="exam-answer-page__title-box">
          <h1 class="heading heading--1 heading--no-margin exam-answer-page__title-text">
            Gabarito do Enem {{ getYear() }}
          </h1>
          <div
            id="selectYearPopover"
            class="exam-answer-page__select-year-popover exam-answer-page__select-year-text"
          >
            <span class="exam-answer-page__select-year-text--cursor-pointer">
              Trocar o ano
              <img
                src="~/assets/images/icons/i-arrow-up.svg"
                alt="Arrow"
                class="exam-answer-page__select-year-icon"
              />
            </span>
          </div>
          <b-popover
            target="selectYearPopover"
            container="selectYearPopover"
            :html="true"
            placement="bottom"
          >
            <span class="exam-answer-page__select-year-text exam-answer-page__select-year-text--in-popover">
              Outros anos
            </span>
            <div class="exam-answer-page__select-year-box">
              <router-link
                v-for="yearOpt in yearsOptions"
                :key="yearOpt"
                :to="`/gabarito/${yearOpt}`"
                class="exam-answer-page__select-year-link exam-answer-page__select-year-text"
              >
                {{ yearOpt }}
              </router-link>
            </div>
          </b-popover>

        </b-col>
      </b-row>
      <hr class="divider" />
      <b-row>
        <b-col class="exam-answer-page__description">
          <p>
            O Enem (Exame Nacional do Ensino Médio) é composto por 180 questões de múltipla escolha e uma redação.
          </p>
          <p>
            Confira abaixo o gabarito extraoficial do Enem {{ getYear() }}.
          </p>
        </b-col>
      </b-row>
      <b-row v-if="examAnswer.year">
        <b-col >
          <no-ssr>
            <div
              v-show="!isLead"
              class="exam-answer-page__box--opacity"
            >
              <lead />
            </div>
          </no-ssr>
          <div class="exam-answer-page__box">
            <b-row>
              <b-col cols="12" class="exam-answer-page__box-item">
                <span class="exam-answer-page__box-text">
                  Selecione o dia da sua prova
                </span>
                <b-form-select
                  v-model="date"
                  :options="datesOptions"
                  class="exam-answer-page__select-box"
                />
              </b-col>
              <b-col cols="12" class="exam-answer-page__box-item exam-answer-page__box-item--more-space">
                <span class="exam-answer-page__box-text">
                  Selecione a sua prova
                </span>
                <ul class="exam-answer-page__color-list">
                  <li
                    class="exam-answer-page__color-item-list"
                    v-for="color in colorOptions"
                    :key="color.color_name"
                    @click="changeColor(color.color_name)"
                  >
                    <div class="pgc-fancy">
                      <input
                        class="pgc-fancy__input"
                        type="radio"
                        :id="`radio${color.color_name}`"
                        :checked="validColor(color.color_name)"
                      />
                      <label
                        class="pgc-fancy__label exam-answer-page__color-label"
                        @click.prevent :for="`radio${color.color_name}`"
                      >
                        <div class="pgc-fancy__box pgc-fancy__box--circle">
                          <div class="pgc-fancy__icon pgc-fancy__icon--circle" />
                        </div>
                        <span
                          class="exam-answer-page__color-fill"
                          :style="{'background-color': color.color_hex}"
                        />
                        <span class="exam-answer-page__color-text">
                          {{ color.color_name }}
                        </span>
                      </label>
                    </div>
                  </li>
                </ul>
              </b-col>
            </b-row>
            <hr class="divider" />
            <b-row>
              <b-col cols="12">
                <exam-answer-card
                  v-for="exam in exams"
                  :key="exam.name"
                  :exam="exam"
                />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      <b-row>
        <div
          class="exam-partner-social__content"
        >
          <partner :year="getYear()" />
          <social-media
            :whatsapp="{ description: this.getTitle(), url: 'https://que.bo/w-gabarito_enem'}"
            :twitter="{ title: this.getTitle(), description: this.getDescription(), hashtags: ['#Enem', '#GabaritoEnem'], url: 'https://que.bo/t-gabarito_enem' }"
            :facebook="{ title: this.getTitle(), description: this.getDescription(), url: 'https://que.bo/f-gabarito_enem' }"
          />
        </div>
      </b-row>
    </b-container>
    <quero-bolsa-info />
  </div>
</template>

<script>
import { getSubMenuAllLinks, getSubMenuUrls } from '~/assets/js/utils/submenu';
import { mapActions, mapState } from 'vuex';
import Breadcrumb from '~/components/breadcrumb/breadcrumb';
import ExamAnswer from '~/models/exam_answer';
import ExamAnswerSocket from '~/models/socket/exam_answer';
import ExamAnswerCard from '~/components/exam/exam-answer-card';
import Lead from '~/components/exam/lead';
import Partner from '~/components/exam/partner';
import QueroBolsaInfo from '~/components/quero-bolsa-info';
import cookie from '~/mixins/cookie';
import SocialMedia from '~/components/exam/social-media';

export default {
  components: {
    Breadcrumb,
    ExamAnswer,
    ExamAnswerCard,
    Lead,
    Partner,
    QueroBolsaInfo,
    SocialMedia,
  },
  mixins: [
    cookie
  ],
  data() {
    return {
      color: null,
      date: null,
      exams: [],
      examAnswerData: null,
      examModel: new ExamAnswer(this.$store),
      isLead: false,
      years: [],
    }
  },
  async mounted() {

    if (window.fbq) {
      fbq('track', 'Lead Gabarito Enem');
    }

    this.isLead = this.hasCookie('gabarito-lead');
    this.setExams();
    this.setSubMenu({ urls: getSubMenuUrls('gabarito') })

    const examModelSocket = new ExamAnswerSocket(this.$socketService.publicSocket, this.$store);
    examModelSocket.connect();
  },
  async asyncData({ params, store, error, query }) {
    try {
      const {
        color_name: color,
        date,
        yearList: years,
        ...examAnswerData
      } = await getExamAnswer(store, params.year, query.color, query.date);


      return {
        color,
        date,
        examAnswerData,
        years,
      };
    } catch (message_error) {
      error({ statusCode: 404, message: 'Not Found' });
    }

    function getExamAnswer(store, year, color, date) {
      const examModel = new ExamAnswer(store);
      return new Promise((resolve, reject) => {
        examModel.get({year: year, color_name: color, date: date}).then((resp) => {
          resolve(resp);
        }, reject);
      });
    }
  },
  computed: {
    ...mapState({
      examAnswers(state) {
        return state.models.exam_answers || [];
      }
    }),
    ...mapState('lead', {
      leadFilled: 'leadFilled',
    }),
    datesOptions() {
      return this.examAnswer.dateList || [];
    },
    colorOptions() {
      return this.examAnswer.colorList || [];
    },
    yearsOptions() {
      return this.years
    },
    listBreadcrumb() {
      return getSubMenuAllLinks('gabarito');
    },
    currentYear() {
      return new Date().getFullYear();
    },
    examAnswer: {
      get() {
        const currentExamAnswer = this.examAnswers.find(examAnswer => (
          examAnswer.date === this.date
            && examAnswer.color_name === this.color
            && examAnswer.color_hex === this.examAnswerData.color_hex
            && examAnswer.notebook === this.examAnswerData.notebook
            && examAnswer.year === this.examAnswerData.year
            && examAnswer.name === this.examAnswerData.name
        )) || {};

        return {
          ...this.examAnswerData,
          ...currentExamAnswer
        }
      },
      set(value) {
        this.examAnswerData = value;
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.changeExamAnswer();
    },
    'date' (to, from) {
      this.changeDate(to);
    },
    examAnswer(_to, _from) {
      this.setExams()
    },
    leadFilled(to, _from) {
      this.isLead = to;
      this.setExams();
    },
  },
  methods: {
    ...mapActions('modal', {
      showModal: 'show',
    }),
    ...mapActions('submenu', {
      setSubMenu: 'setSubMenu'
    }),
    changeColor(newColor) {
      if (newColor) {
        this.color = newColor
        let path = `/gabarito/${this.getYear()}?date=${this.date}&color=${newColor}`;
        this.$router.push({path: path, params: {}})
      }
    },
    changeDate(newDate) {
      if (newDate) {
        this.color = null;
        let path = `/gabarito/${this.getYear()}?date=${newDate}`;
        this.$router.push({path: path, params: {}});
      }
    },
    changeExamAnswer() {
      this.examModel.get({year: this.getYear(), color_name: this.color, date: this.date}).then((resp) => {
        this.examAnswer = resp;
        this.color = this.examAnswer.color_name;
      });
    },
    setExams() {
      if (this.examAnswer && this.isLead) {
        this.exams= this.examAnswer.exams;
      }
    },
    validColor(colorName) {
      return this.color == colorName;
    },
    getYear() {
      if(this.examAnswer && this.examAnswer.year) {
        return this.examAnswer.year
      }
      return this.$route.params.year;
    },
    getTitle() {
      return `Gabarito do Enem ${this.getYear()} | Manual do Enem`;
    },
    getDescription() {
      const text = (this.getYear() == this.currentYear) ?
        'Veja o gabarito extraoficial do Enem liberado no dia do exame. Basta selecionar a data e cor da prova.' :
        'Veja o gabarito oficial do Enem liberado pelo INEP. E também provas de anos anteriores.';

      return `Gabarito do Enem ${this.getYear()}: aqui você pode ver os gabaritos do primeiro e segundo dia de prova. ${text}`;
    },
  },
  head() {

    let metaTags = [
      { hid: 'description', name: 'description', content: this.getDescription()},
      // Open Graph
      { property: 'og:title', content: this.getTitle() },
      { property: 'og:description', content: this.getDescription() },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://querobolsa.com.br/enem/gabarito'
      },
      { property: 'og:image', content: 'https://manual-do-enem-test.s3-sa-east-1.amazonaws.com/home-cover-gabarito.png' },
      { property: 'fb:app_id', content: process.env.FB_APP_ID }
    ];

    let accessYear = parseInt(this.getYear())

    if (accessYear == NaN || accessYear > this.currentYear) {
      metaTags.push({ name: 'robots', content: 'noindex' });
    }

    return {
      title: this.getTitle(),
      meta: metaTags,
      link: [{ rel: 'canonical', href: 'https://querobolsa.com.br/enem/gabarito' }],
      script: [
        {
          type: 'text/javascript',
          src: 'https://d335luupugsy2.cloudfront.net/js/lead-tracking/stable/plugins/math.uuid.v1.4.min.js',
          async: true,
          body: true
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@quero/zilla-core/src/utils/functions.scss";
  @import "@quero/zilla-core/src/utils/variables.scss";

  .exam-answer-page {
    background-color: var(--color-neutral-gray-lightest);
    margin-bottom: $space-m;
    padding-top: $space-m;
  }

  .exam-answer-page__title-box {

    @media (min-width: $screen-sm-min) {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
    }
  }

  .exam-answer-page__title-text {

    @media (min-width: $screen-sm-min) {
      float: left;
    }
  }

  .exam-answer-page__select-year-popover {
    float: left;

    @media (min-width: $screen-sm-min) {
      margin-left: $space-m;
    }

    &[aria-describedby] {
      .exam-answer-page__select-year-icon {
        transform: none;
      }
    }
  }

  .exam-answer-page__select-year-box {
    display: flex;
    flex-wrap: wrap;
  }

  .exam-answer-page__select-year-link {
    display: flex;
    flex: 1 0 25%;
  }

  .exam-answer-page__select-year-text {
    color: var(--color-brand-primary-pure);
    font-size: rem(16);
    font-weight: $font-weight-bold;
  }

  .exam-answer-page__select-year-text--cursor-pointer {
    cursor: pointer;
  }

  .exam-answer-page__select-year-text--in-popover {
    color: var(--color-neutral-gray-darker);
    text-decoration: none;
  }

  .exam-answer-page__select-year-icon {
    transform: rotate(180deg);

    &[aria-describedby] {
      transform: rotate(180deg);
    }
  }

  .exam-answer-page__description {
    color: var(--color-neutral-gray-darker);
  }

  .exam-answer-page__box {
    background-color: var(--color-neutral-white);
    border: 1px solid var(--color-neutral-gray-light);
    box-shadow: $low-box-shadow;
    display: flex;
    flex-direction: column;
    height: auto;
    margin: 0 -15px;
    min-height: 450px;
    padding: 0 $space-m;
    position: relative;

    @media (min-width: $screen-sm-min) {
      border-radius: $border-radius;
      margin: 0;
      min-height: 600px;
      padding: 0 $space-st;
    }
  }

  .exam-answer-page__box--opacity {
    align-items: center;
    background: linear-gradient(0deg, var(--color-neutral-white) 70%, rgba(255, 255, 255, 0.63));
    display: flex;
    justify-content: center;
    height: 100%;
    margin: 0 -15px;
    max-width: 1110px;
    padding: 0 $space-m;
    position: absolute;
    width: 100%;
    z-index: 2;

    @media (min-width: $screen-sm-min) {
      margin: 0;
    }
  }

  .exam-answer-page__box-item {
    margin-top: $space-st;

    @media (min-width: $screen-sm-min) {
      flex: 1 1 0;
      flex-grow: 1;
    }
  }

  .exam-answer-page__box-item--more-space {

    @media (min-width: $screen-sm-min) {
      flex-grow: 2;
    }
  }

  .exam-answer-page__box-text {
    color: var(--color-neutral-gray-clear);
    font-size: rem(16);
    font-weight: $font-weight-bold;
    width: 100%;
  }

  .exam-answer-page__select-box {
    margin-top: $space-s;
  }

  .exam-answer-page__color-list {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    @media (min-width: $screen-sm-min) {
      flex-grow: 2;
    }
  }

  .exam-answer-page__color-item-list {
    flex: 0 50%;
    list-style: none;
    margin-right: 0;
    margin-top: $space-s;

    @media (min-width: $screen-sm-min) {
      flex-basis: auto;
      margin-right: $space-st;
    }
  }

  .exam-answer-page__color-label {
    align-items: center;
    cursor: pointer;
  }

  .exam-answer-page__color-fill {
    border: 1px solid var(--color-neutral-gray-light);
    border-radius: $border-radius;
    display: flex;
    float: left;
    height: $space-st;
    margin-right: $space-s;
    width: $space-st;
  }

  .exam-answer-page__color-text {
    color: var(--color-neutral-gray-clear);
    font-size: rem(16);
    font-weight: $font-weight-normal;
  }

  .exam-partner-social__content {
    margin-left: $space-m;
    margin-right: $space-m;

    @media (min-width: $screen-desktop) {
      display: flex;
    }
  }
</style>
